module.exports = __webpack_public_path__ + "static/media/travel-bg-right.3e46b3e3.jpg";